// AUTO-GENERATED from PostEx_Cities_Cleaned.csv (source of truth). Do not hand-edit.
// 466 unique PostEx shipping cities. Exact spelling preserved (uppercase).
// Used by /pages/Checkout.jsx (searchable combobox).

export const POSTEX_SHIPPING_CITIES = [
  "AIMANABAD TOWN",
  "AJNIA WALA",
  "AKHTAR ABAD",
  "AKORA KHATAK",
  "ALI PUR BANGLA",
  "ALIPUR",
  "ALPUR CHATHA",
  "AMANGARH",
  "AMINABAD",
  "ANWARABAD",
  "ARIFWALA",
  "ARIA",
  "ASHARAY",
  "ATHMUQAM",
  "ATTOCK",
  "AYUBIA",
  "BAHRIA ORCHARD GRE",
  "BAHTAR MORE",
  "BAIDARA",
  "BAIG PUR",
  "BAJAR WALA",
  "BALAMBAT",
  "BAN BAJWA",
  "BANGULDERO",
  "BARA MANCA",
  "BASIRPUR",
  "BADIN",
  "BAHAWALNAGAR",
  "BAHAWALPUR",
  "BHAL SYEDAN",
  "BHALWAAL",
  "BHAUGHASITPUR",
  "BONGA HAYAT",
  "BOSAL",
  "BOZDAR WAPAN",
  "BUCHEKE",
  "BUNER",
  "CHAK FATEH SHAH",
  "CHAK HAMD",
  "CHAK JAN",
  "CHAK JHUMRA",
  "CHAK PARANA",
  "CHAKDARA",
  "CHAKLALA",
  "CHANGA MANGA",
  "CHANNAN",
  "CHAR BAGH",
  "CHARHOI",
  "CHARSADDA",
  "CHASHMA",
  "CHAUBARA",
  "CHAWINDA",
  "CHIANWALI",
  "CHINIOT",
  "CHISHTIAN",
  "CHITRAL",
  "CHITTA MORE",
  "CHOA KHALSA",
  "CHOA SAIDAN SHAH",
  "CHUHAR JAMALI",
  "DADU",
  "DAND",
  "DARYA GALI",
  "DARYA KHAN",
  "DASKA",
  "DAUD KHEL",
  "DAULATPUR",
  "DEHARKI",
  "DEPALPUR",
  "DERA ALLAH YAR",
  "DEWAL",
  "DEWANA BABA",
  "DHARABI",
  "DHARYALA JALAP",
  "DHIRKOT",
  "DHOKE SHAHANI",
  "DHORIADDA",
  "DIGRI",
  "DIJKOT",
  "DILAWAR",
  "DINGA",
  "DISTRICT AVAN",
  "DOBE",
  "DUDHU CHAK",
  "DULLE WALA",
  "DUNIAPUR",
  "DUNYA PUR",
  "FAISALABAD",
  "FAQIRWALI",
  "FARHAT ABAD",
  "FAROOQABAD",
  "FATEH JANG",
  "FEROZ WATWAN",
  "F.F.C. PLANT",
  "GAMBA SKARDU",
  "GAMBAT",
  "GARH MORE",
  "GARHA MORE",
  "GARHI DUPATTA",
  "GARHI MORI",
  "GATWALA",
  "GHAKKAR MANDI",
  "GHAR MORE",
  "GHARI HABIBULLAH",
  "GHARIBWAL",
  "GHARIBWAL CEMENT",
  "GHARO",
  "GHAZIABAD",
  "GHIKA GALI",
  "GHORA GALI",
  "GHOUR GHUSTI",
  "GHOUS PUR",
  "GHOUSPUR",
  "GHUMMAN WALA",
  "GOLARCHI",
  "GOLPUR",
  "GOTHMACH",
  "GUJRANWALA",
  "GUJRAT",
  "GULIANA",
  "GUMTI SHAREEF",
  "GUNJA",
  "GURMANI ADDA",
  "GWADAR",
  "HABIB ABAD",
  "HAFIZABAD",
  "HAJRA",
  "HAKIM ABAD",
  "HARANPUR",
  "HARIGHEL",
  "HARIPUR",
  "HARNAL",
  "HAROONABAD",
  "HASILPUR",
  "HASSAN ABDAL",
  "HATIA BALA",
  "HATTAR",
  "HATTIAN BALA",
  "HAZARA",
  "HAVELIAN",
  "HARIAN",
  "HATTIAN",
  "HYDERABAD",
  "IKHLAS",
  "IKHLASPUR",
  "IQBAL ABAD",
  "IQBAL NAGAR",
  "ISLAM GARH (AJK)",
  "ISLAM HEADWORKS",
  "ISLAMABAD",
  "JALALPUR BHATTIAN",
  "JALALPUR JATTAN",
  "JALALPUR SHARIF",
  "JALALPUR PIRWALA",
  "JAMALPUR",
  "JAMKE CHATHA",
  "JAMMU",
  "JAMSHORO",
  "JHELUM",
  "KACHA KHOO",
  "KACHURA",
  "KADHAN",
  "KAHUTA",
  "KAIRPUR NATHIN SHAH",
  "KALASKE CHEEMA",
  "KALLAR SYEDAN",
  "KAMRIAL",
  "KAND KOT",
  "KANGANPUR",
  "KANIANPUR",
  "KARACHI SADDAR",
  "KARAK",
  "KARAMPUR",
  "KARARIWALA KHURD",
  "KARIALA JALIB",
  "KAROOR PAKA",
  "KAROR LAL EASAN",
  "KARTARPUR",
  "KASHMIR POINT",
  "KASHMORE",
  "KASSOWAL",
  "KHAI GALA",
  "KHAIRPUR",
  "KHAIRPUR MEERUS",
  "KHAIRPUR NATHAN SHAH",
  "KHAIRPUR TAMEWAL",
  "KHAN BELA",
  "KHAN GHAR",
  "KHANEWAL",
  "KHANPUR",
  "KHANPUR MAHAR",
  "KHAPLU",
  "KHARMANG",
  "KHASBEHAAL",
  "KHAUR",
  "KHIDARWAL",
  "KHIPRO",
  "KHOAZA KHAIL",
  "KHOHAR",
  "KHORI ALAM",
  "KHUDIAN",
  "KHUSHAB",
  "KHUZDAR",
  "KHWAZAKHELA",
  "KHWERA",
  "KINGRA MOR",
  "KOHAT",
  "KOT ASLAM",
  "KOT BANGLO",
  "KOT FATEH KHAN",
  "KOT GHULAM MUHAMMAD",
  "KOT MITHAN",
  "KOT MOMIN",
  "KOT NAINAN",
  "KOT PINDI DAS",
  "KOT QADIR BAKHSH",
  "KOT RADHA KISHAN",
  "KOT SAMABAH",
  "KOTLI",
  "KOTLI LOHARAN",
  "KOTRI",
  "KOTRIMUHAMMAD KAGIR",
  "KUCHLAK",
  "KULDANA",
  "KULDA",
  "KULWAL",
  "LAHORE",
  "LAHORE CANTT",
  "LAKE CITY",
  "LAKHA ROAD",
  "LAKKI MARWAT",
  "LALIAN",
  "LAYYAH",
  "LESSAR KALAN",
  "LAQAT NATIONAL BAGH",
  "LAGAR PUR",
  "LOWER TOPA",
  "MADRASSA CHATTHA",
  "MAKLI",
  "MALAKWAL",
  "MALAKAND",
  "MANAWALA",
  "MANCHAR",
  "MANDI BAHAUDDIN",
  "MANDI BUCHIANA",
  "MANDI SAFDAR ABAD",
  "MANDI USMAN WALA",
  "MANDIAN",
  "MANGA MANDI",
  "MANGLA",
  "MANSEHRA",
  "MANTHAL",
  "MARDAN",
  "MASAR CAMP",
  "MATIARI",
  "MATTA",
  "MEHAR",
  "MEHDIABAD",
  "MIAN CHANNU",
  "MIAN WALI QURESHIAN",
  "MIANA GONDAL",
  "MIANDAM",
  "MANWAL BANGLA",
  "MINCHINABAD",
  "MIRPUR MATHELO",
  "MIRPUR SAKRO",
  "MORO",
  "MUNDA",
  "MUNDI KHEL",
  "MURAT TAN",
  "MURIDKE",
  "MURREE",
  "MUZAFFARGARH",
  "NASARPUR",
  "NASIRABAD",
  "NATHIA GALI",
  "NAUSHAHRO FEROZE",
  "NAWABSHAH",
  "NAWAY KALI",
  "NAYA LAHORE",
  "NEW INDUSTRIAL AREA",
  "NEW MURREE",
  "NEW TOWN KARACHI",
  "NIZAMABAD",
  "NOMAN PURA",
  "NOOR COLONY",
  "NOOR JAMAAL",
  "NOOR KOT",
  "NOORPUR",
  "NORTH",
  "NORIABAD",
  "NOWSHERA",
  "NOWSHERA KALAN",
  "NOWSHERA VIRKAN",
  "NRTC",
  "OLDING",
  "OLD POWER PLANT",
  "PABBI",
  "PACHNAND",
  "PAKPATTAN SHARE",
  "PAKKA LARAN",
  "PAKPATTAN",
  "PASNI",
  "PASROOR",
  "PASROOR ROAD AND VILLAGES",
  "PATHIKA",
  "PATOKI",
  "PATRIATA",
  "PATTOKI",
  "PEER MAHAL",
  "PESHAWAR",
  "PHAGWARI",
  "PINANWAL",
  "PIND DADAN KHAN",
  "PINDI BHATIAN",
  "PINDI GHEB",
  "PINDI GUJRAN",
  "PINDI POINT",
  "PINDI SAIDPUR",
  "PIRBABA",
  "PIR JOGOTH",
  "PIR WASAN",
  "PIRA FATEH ALI",
  "PISHIN",
  "PITARO",
  "PMA KAKUL",
  "POONCH (AJK)",
  "PORANWALA",
  "PUNJAR",
  "PUNWAN",
  "QALIMPUR",
  "QALAT",
  "QAMAR ABAD",
  "QAMAR MASHANI",
  "QAMBAR",
  "QASIMPURA",
  "QAZI AHMED",
  "QILA AHMED ABAD",
  "QILA DEEDAR SING",
  "QILLA KALAR WALA",
  "QABAL",
  "QABOOLA SHARIF",
  "QADIR PUR RAWAN",
  "RAHAT",
  "RACHNA TOWN",
  "REHOKA",
  "RAHIM YAR KHAN",
  "RAJA JANG",
  "RAJANA",
  "RANIPUR",
  "RAKHBALOCH KALAN",
  "RASHKAI",
  "RASOOL NAGAR",
  "RATO DERO",
  "RATODERO",
  "RAWALPINDI",
  "RENALA KHURD",
  "RISALPUR",
  "ROHRI",
  "ROUNDU",
  "SAGHAR PUR",
  "SAHIWAL",
  "SAJ NAGAR",
  "SAIDU SHARIF",
  "SANGHAR",
  "SAJAWAL",
  "SAKRAND",
  "SALLHOKE CHATTHA",
  "SAMAR BAGH",
  "SAMARO",
  "SAMBRIAL",
  "SAMOTE",
  "SANGLA HILL",
  "SANGWALA",
  "SANJHORO",
  "SANJWAL",
  "SARAIALAMGIR",
  "SARAI MUGHAL",
  "SARYE NORANG",
  "SARDARYAB",
  "SARGODHA",
  "SAROPA",
  "SAROKI CHEEMA",
  "SAWABI",
  "SAWARI",
  "SHAHDAD KOT",
  "SHAHDAD PUR",
  "SHAHDADPUR",
  "SHAHDARA TOWN",
  "SHAHKOT",
  "SHAHPUR SAHANIA",
  "SHAHPUR",
  "SHAMKOT",
  "SHARAQPUR SHARIF",
  "SHARIF MEDICAL CITY",
  "SHEIKHOO SUGAR MILLS",
  "SHEIKHUPURA",
  "SHERGARH",
  "SHIMLA HILL",
  "SHOKHDARA",
  "SHORKOT",
  "SHORKOT CANTONMENT",
  "SHUJABAD",
  "SIALKOT",
  "SIHALA",
  "SIKANDARABAD",
  "SINJHORO",
  "SIR SUBA SHAH",
  "SIRAYE MUHAJR",
  "SKARDU",
  "SMALL INDUSTRIAL ESTATE DASKA",
  "SOHAWA",
  "SOKAR",
  "SUDHANOTI (AJK)",
  "SUI TOWN",
  "SUKKUR",
  "SUMBRIAL",
  "SUNDER INDUSTRIAL ESTATE",
  "SUNDER ADDA",
  "SWABI",
  "SWAT",
  "SYED WALA",
  "T.T. SINGH",
  "TAKHT-E-BHAI",
  "TAKHT-I-BAHI",
  "TALAGUNG",
  "TALASH",
  "TALHAR",
  "TAMMAN",
  "TAXILA",
  "TAXLA",
  "THARI MIRWAH",
  "THATTA",
  "THEENG MORE (ALLAHA ABAD)",
  "THOA MEHRAM KHAN",
  "THOA KHALSA",
  "THUL",
  "THU HAMZA",
  "TOBA TEK SINGH",
  "TOBAH",
  "TOPA ADAM",
  "TOPI",
  "TOPI (GIK UNIVERSITY ONLY)",
  "TORWARSAK",
  "TRANDA MOHAMMAD PANAH",
  "TRANDA SAWAY KHAN",
  "UBAURO",
  "UCH SHARIF",
  "UGGOKE",
  "UPPER CHITRAL",
  "UPPER DIR",
  "USTA MOHAMMAD",
  "USTA MUHAMMAD",
  "WADA MACHHI",
  "WAH CANTT",
  "WAPDA TOWN",
  "WAPDA COLONY (AJK)",
  "WARIS WALA",
  "WARBATTAN",
  "WARRAICHAN WALA",
  "WAZIR K CHATTHA",
  "WAZIRABAD",
  "WINDER",
  "ZAFARWAL",
  "ZAHIR PIR",
  "ZHOB",
];
